import {
  CylinderGeometry,
  InstancedMesh,
  Matrix4,
  MeshBasicMaterial,
  Vector3,
} from 'three';
import { rand } from '../util/math.js';

let weather = null;

const matrix = new Matrix4();
const scale = new Vector3(0.012, 0.42, 0.012);

export function initWeather(world, options = {}) {
  const {
    count = 260,
    color = 0x8fd7ff,
  } = options;

  const positions = new Float32Array(count * 3);
  const velocities = new Float32Array(count);
  for (let i = 0; i < count; i += 1) {
    resetDrop(i, positions, velocities, world, { x: 0, z: 0 }, true);
  }

  const geometry = new CylinderGeometry(1, 1, 1, 5);
  const material = new MeshBasicMaterial({
    color,
    transparent: true,
    opacity: 0.34,
    depthWrite: false,
  });
  const rain = new InstancedMesh(geometry, material, count);
  rain.name = 'rain';
  rain.frustumCulled = false;
  world.weatherRoot.add(rain);

  weather = { rain, positions, velocities, count, world };
  updateRainMatrices();
  return weather;
}

export function getWeather() {
  if (!weather) {
    throw new Error('[weather] initWeather() must run before getWeather().');
  }
  return weather;
}

export function updateWeather(dt, options = {}) {
  if (!weather?.rain) return;

  const {
    playerPosition = { x: 0, z: 0 },
    quality = 'high',
    overdrive = false,
  } = options;
  const { positions, velocities, count, world } = weather;

  for (let i = 0; i < count; i += 1) {
    const j = i * 3;
    positions[j + 1] -= velocities[i] * dt;
    positions[j] -= dt * 2.8;
    if (positions[j + 1] < 0.3) {
      resetDrop(i, positions, velocities, world, playerPosition);
    }
    if (positions[j] < -world.half) positions[j] += world.size;
  }

  weather.rain.material.opacity = quality === 'low' ? 0.16 : overdrive ? 0.5 : 0.34;
  updateRainMatrices();
}

export function modulateFog(scene, targetDensity, lerpAlpha = 0.08) {
  if (!scene?.fog) return;
  scene.fog.density += (targetDensity - scene.fog.density) * lerpAlpha;
}

function resetDrop(index, positions, velocities, world, playerPosition, initial = false) {
  const j = index * 3;
  positions[j] = (initial ? 0 : playerPosition.x) + rand(-world.half, world.half);
  positions[j + 1] = initial ? rand(5, 34) : rand(17, 36);
  positions[j + 2] = (initial ? 0 : playerPosition.z) + rand(-world.half, world.half);
  velocities[index] = rand(18, 32);
}

function updateRainMatrices() {
  const { rain, positions, count } = weather;
  for (let i = 0; i < count; i += 1) {
    const j = i * 3;
    matrix.compose(
      new Vector3(positions[j], positions[j + 1], positions[j + 2]),
      rain.quaternion,
      scale,
    );
    rain.setMatrixAt(i, matrix);
  }
  rain.instanceMatrix.needsUpdate = true;
}
